import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFConsentsApi } from '../../../apis/EICFApi/EICFConsentsApi.ts';

export function useGetMySignedEICFConsent(enabled: boolean = true) {
  return useQuery({
    queryKey: [QueryKeys.eicfMySignedConsent],
    queryFn: () => EICFConsentsApi.getMySigned(),
    enabled,
    staleTime: 30_000,
    refetchOnMount: 'always',
  });
}
